export const broadCastNearby = [
  {
    breakpoint: 1366,
    settings: {
      slidesToShow: 6,
      slidesToScroll: 6,
    },
  },
  {
    breakpoint: 1200,
    settings: {
      slidesToShow: 5,
      slidesToScroll: 5,
    },
  },
  {
    breakpoint: 1024,
    settings: {
      slidesToShow: 4,
      slidesToScroll: 4,
    },
  },
  {
    breakpoint: 992,
    settings: {
      slidesToShow: 4,
      slidesToScroll: 4,
    },
  },
  {
    breakpoint: 970,
    settings: {
      slidesToShow: 4,
      slidesToScroll: 4,
    },
  },
  {
    breakpoint: 850,
    settings: {
      slidesToShow: 3.4,
      slidesToScroll: 3,
    },
  },
  {
    breakpoint: 768,
    settings: {
      slidesToShow: 3.2,
      slidesToScroll: 3,
    },
  },
  {
    breakpoint: 650,
    settings: {
      slidesToShow: 2.3,
      slidesToScroll: 2,
    },
  },
  {
    breakpoint: 647,
    settings: {
      slidesToShow: 2.4,
      slidesToScroll: 2,
    },
  },
  {
    breakpoint: 600,
    settings: {
      slidesToShow: 2.2,
      slidesToScroll: 2,
    },
  },
  {
    breakpoint: 480,
    settings: {
      slidesToShow: 1.3,
      slidesToScroll: 1,
      centerMode: false,
      centerPadding: '0px',
    },
  },
  {
    breakpoint: 464,
    settings: {
      slidesToShow: 1.5,
      slidesToScroll: 1,
      centerMode: false,
      centerPadding: '0px',
    },
  },
  {
    breakpoint: 400,
    settings: {
      slidesToShow: 1.4,
      slidesToScroll: 1,
      centerMode: false,
      centerPadding: '0px',
    },
  },
  {
    breakpoint: 360,
    settings: {
      slidesToShow: 1.5,
      slidesToScroll: 1,
      centerMode: false,
      centerPadding: '0px',
    },
  },
  {
    breakpoint: 300,
    settings: {
      slidesToShow: 1.6,
      slidesToScroll: 1,
      centerMode: false,
      centerPadding: '0px',
    },
  },
  {
    breakpoint: 280,
    settings: {
      slidesToShow: 1.7,
      slidesToScroll: 1,
      centerMode: false,
      centerPadding: '0px',
    },
  },
];
export const AboutPageSlider = [
  {
    breakpoint: 1366,
    settings: {
      // centerMode: true,
      slidesToShow: 1,
      slidesToScroll: 1,
    },
  },
  {
    breakpoint: 1200,
    settings: {
      // centerMode: true,
      slidesToShow: 1,
      slidesToScroll: 1,
    },
  },
  {
    breakpoint: 1024,
    settings: {
      // centerMode: true,
      slidesToShow: 1,
      slidesToScroll: 1,
    },
  },
  {
    breakpoint: 992,
    settings: {
      // centerMode: true,
      slidesToShow: 1,
      slidesToScroll: 1,
    },
  },
  {
    breakpoint: 768,
    settings: {
      // centerMode: true,
      slidesToShow: 1,
      slidesToScroll: 1,
    },
  },
  // {
  //   breakpoint: 600,
  //   settings: {
  //     slidesToShow: 3,
  //     slidesToScroll: 3,
  //     vertical: true,
  //     arrows: true,
  //   },
  // },
];

